import React, { ForwardedRef } from 'react';

import { isMobile } from 'react-device-detect';
import PerfectScrollbar, { ScrollBarProps } from 'react-perfect-scrollbar';

export interface ScrollbarRef {
	_ps: {
		element: HTMLDivElement;
	};
}

export const Scrollbar = React.forwardRef<
	ScrollbarRef,
	ScrollBarProps & { forceNative?: boolean }
>(({ children, forceNative, ...rest }, ref) => {
	return isMobile || !!forceNative ? (
		<div ref={ref as ForwardedRef<HTMLDivElement>} {...rest}>
			{children}
		</div>
	) : (
		<PerfectScrollbar ref={ref as ForwardedRef<PerfectScrollbar>} {...rest}>
			{children}
		</PerfectScrollbar>
	);
});
